// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__37zw0","head":"Table_head__cFdPU","col":"Table_col__y-RTc"};